module.exports = __webpack_public_path__ + "static/media/icon-google.02d31de0.svg";